module.exports = __webpack_public_path__ + "static/img/inviteRulePageBg.28ea4d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/inviteRulePageBg.png
// module id = qXhG
// module chunks = 0